'use client';
var COMPONENT_ID = "Stack";
var defaultProps = {
    spacing: "4s",
    align: "stretch",
    justify: "flex-start"
};

export { COMPONENT_ID, defaultProps };
